export const LocalStorageKeys = {
    I18_NEXT_LNG: "i18nextLng",
    TOKEN: "accessToken",
};
